import { SkeletonDisplayText } from "@shopify/polaris";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  .Polaris-SkeletonDisplayText__DisplayText {
    height: 2rem;
    max-width: 8rem;
  }
`;

export default function SkeletonText() {
  return (
    <Wrapper>
      <SkeletonDisplayText />
    </Wrapper>
  );
}
